import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'aa-content-header',
    templateUrl: './content-header.component.html',
    styleUrls: [
        './content-header.component.scss'
    ],
    standalone: false
})
export class ContentHeaderComponent implements OnInit
{
    @Input() percentLeftPart: number = 100 / 3;
    @Input() percentMiddlePart: number;
    percentRightPart: number = 100 / 3;

    ngOnInit ()
    {
        this.percentRightPart = this.percentLeftPart;
    }
}
